import * as React from "react";
import { Link, LinkProps } from "react-router-dom";
import Tab, { TabProps } from './Tab';
import { LocationDescriptor } from 'history';

interface LinkTabProps {
    label?: React.ReactNode;
    disabled?: boolean;
    to: LocationDescriptor;
}

class LinkTab extends React.PureComponent<LinkTabProps> {

    render() {
        const { label, disabled, to } = this.props;
        return <Tab label={label} disabled={disabled} component={(props) => <Link to={to} {...props} />} />;
    }
}

export default LinkTab;

